<template>
  <v-card
      :class="{getCardClass, 'my-1': hover}"
      :elevation="hover ? 6 : 0"
      v-on="$listeners"

      @mouseenter="hover=true"
      @mouseleave="hover=false"
      flat
  >
      <slot></slot>
    <v-btn
           v-if="enableEdit && hover"
           color="blue"
           icon
           absolute :style="{top: '5px', right: '5px'}"
           @click="$emit('edit')"
    >
      <v-icon>edit</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
export default {
  name: "CardEdit",
  props: {
    textColor: {type: String, default: ""},
    backgroundColor: {type: String, default: "white"},
    enableEdit: {type: Boolean, default: true}
  },
  data(){
    return {
      hover: false
    }
  },
  computed: {
    getCardClass() {
      return this.textColor + ' ' + this.backgroundColor
    }
  }
}
</script>

<style scoped>
.noSelect {
  user-select: none;
}
</style>
